module.exports = __webpack_public_path__ + "static/media/2.eddfafa0.jpg";